import { useState, useEffect, useRef } from 'react';
import { Text, Box, Button, Input, Divider, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { DashboardSection } from '../../components/DashboardStyles';
import CustomAccordion from './CustomAccordion';
import { BiChevronLeft, BiPlus } from 'react-icons/bi';
import { BsPlusLg } from 'react-icons/bs';
import { FiEye } from 'react-icons/fi';
import {
    add_to_store,
    get_ordered_products,
    update_variant_table,
} from 'redux/actions/storeActions';
import * as prodTypes from 'redux/actionTypes';

export default function CreateProduct() {
    const fileInput = useRef(null);
    // eslint-disable-next-line no-unused-vars
    const [dragActive, setDragActive] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const storeReducer = useSelector((state) => state.storeReducer);
    const { product, orderedProduct, productCreated } = storeReducer;
    const [selectedImage, setSelectedImage] = useState('');
    const [productDetail, setProductDetail] = useState({});

    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true);
        } else if (e.type === 'dragleave') {
            setDragActive(false);
        }
    };

    useEffect(() => {
        dispatch(get_ordered_products());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const general = product?.general ? JSON.parse(product.general) : {};
        const inventry = product?.inventry ? JSON.parse(product.inventry) : {};
        const pricing = product?.pricing ? JSON.parse(product.pricing) : {};
        const variant = product?.variant ? JSON.parse(product.variant) : {};
        setProductDetail({
            sku: product?.sku,
            image: product?.image,
            general: {
                name: general?.name,
                prefered_name: general?.prefered_name,
                category: general?.category,
                description: general?.description,
            },
            inventry: {
                prefered_sku: inventry?.prefered_sku ? inventry.prefered_sku : product?.sku,
                quantity: inventry?.quantity ? inventry.quantity : product?.sku,
                allow_over_sale: inventry?.allow_over_sale,
            },
            pricing: {
                regular_price: pricing?.regular_price,
                sale_price: pricing?.sale_price,
                cost_per_item: pricing?.cost_per_item,
            },
            variant: {
                Size: variant?.Size,
                Color: variant?.Color,
                options: variant?.options,
            },
        });

        if (productCreated) {
            dispatch({ type: prodTypes.CLEAR_STORE_ACTIONS });
            navigate('/dashboard/store');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product, productCreated]);

    const handleChange = (e) => {
        if (['name', 'prefered_name', 'category', 'description'].includes(e.name)) {
            if (e.name === 'name') {
                productDetail.sku = e.value;
                productDetail.general[e.name] = e.selectedOptions[0].text;
            } else {
                productDetail.general[e.name] = e.value;
            }
            return setProductDetail(productDetail);
        }

        if (['quantity', 'allow_over_sale', 'prefered_sku'].includes(e.name)) {
            productDetail.inventry[e.name] = e.name === 'allow_over_sale' ? e.checked : e.value;
            return setProductDetail(productDetail);
        }

        if (['regular_price', 'sale_price', 'cost_per_item'].includes(e.name)) {
            productDetail.pricing[e.name] = e.value;
            return setProductDetail(productDetail);
        }

        if (['Size', 'Color', 'options'].includes(e.name)) {
            productDetail.variant[e.name] = e.value;
            dispatch(update_variant_table({ name: e.name, value: e.value }));
            return setProductDetail(productDetail);
        }

        productDetail[e.name] = e.value;
        return setProductDetail(productDetail);
    };

    const handleSubmit = () => {
        dispatch(add_to_store(productDetail, selectedImage));
    };

    return (
        <DashboardSection>
            <Box
                display="flex"
                flexDirection={{
                    base: 'column',
                    sm: 'column',
                    md: 'row',
                    lg: 'row',
                }}
                gap={{
                    base: '1rem',
                    sm: '1rem',
                    md: '',
                    lg: '',
                }}
                justifyContent="space-between"
                marginBottom="2rem"
                bg="#fafafa"
                py="5"
                zIndex="dropdown"
                top="0"
                position="sticky">
                <Flex
                    alignItems="center"
                    gap="1"
                    onClick={() => navigate('/dashboard/store/products')}
                    cursor="pointer">
                    <Text fontSize="xl">
                        <BiChevronLeft />
                    </Text>
                    <Text
                        fontSize={{
                            base: '.8rem',
                            sm: '.8rem',
                            md: '1rem',
                            lg: '1rem',
                        }}>
                        Back to Products
                    </Text>
                </Flex>
                <Box
                    display="flex"
                    flexDirection={{
                        base: 'column',
                        sm: 'column',
                        md: 'row',
                        lg: 'row',
                    }}
                    alignItems={{
                        base: 'start',
                        sm: 'start',
                        md: 'center',
                        ld: 'center',
                    }}
                    gap="1rem">
                    <Button
                        display="flex"
                        alignItems="center"
                        gap="2"
                        variant="outline"
                        leftIcon={<FiEye />}
                        onClick={() =>
                            window.open('/dashboard/store/products/preview-product', '_blank')
                        }>
                        <Text
                            fontSize={{
                                base: '.8rem',
                                sm: '.8rem',
                                md: '1rem',
                                lg: '1rem',
                            }}>
                            Preview
                        </Text>
                    </Button>
                    <Button
                        display="flex"
                        alignItems="center"
                        gap=".5rem"
                        background="#1b3b5f"
                        color="#ffffff"
                        onClick={handleSubmit}
                        leftIcon={<BiPlus />}>
                        <Text
                            fontSize={{
                                base: '.8rem',
                                sm: '.8rem',
                                md: '1rem',
                                lg: '1rem',
                            }}>
                            Create Product
                        </Text>
                    </Button>
                </Box>
            </Box>
            <Divider marginBottom="2rem" />
            <Box
                display="grid"
                gridTemplateColumns={{
                    base: '1fr',
                    sm: '1fr',
                    md: '1fr',
                    lg: '1fr 1fr',
                }}
                gap="4rem">
                <Box width="100%">
                    <Box marginBottom="2rem">
                        <Text fontWeight="500" fontSize="lg">
                            Create Product
                        </Text>
                        <Text>push product from your previous order</Text>
                    </Box>
                    <Box>
                        <CustomAccordion
                            productDetail={productDetail}
                            orderedProduct={orderedProduct}
                            handleChange={handleChange}
                        />
                    </Box>
                </Box>
                <Box
                    width="100%"
                    height="18rem"
                    background="#F2F4F7"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    gap="1rem"
                    cursor="pointer"
                    onDragEnter={handleDrag}
                    onDragOver={handleDrag}>
                    <Box
                        color="#3D78F9"
                        display="flex"
                        alignItems="center"
                        gap="1rem"
                        onClick={() => fileInput.current.click()}>
                        <Text>
                            <BsPlusLg />
                        </Text>
                        <Input
                            type="file"
                            ref={fileInput}
                            hidden
                            onChange={(e) => setSelectedImage(e.target.files[0])}
                        />
                        <Text fontSize="sm">Add Images</Text>
                    </Box>
                    <Text fontSize="sm" textAlign="center">
                        Drop your images here, or click to browse
                    </Text>
                </Box>
            </Box>
        </DashboardSection>
    );
}
